<template>
  <div class="locale-changer"
       v-tooltip="$t('message.generics.message.changeLanguage')">
    <select v-model="$i18n.locale"
            @change="setLocale($event)"
            id="select">
      <option v-for="(locale, i) in locales"
              :key="`locale-${i}`"
              :value="locale.value">
        &nbsp;&nbsp;{{`${locale.label}`}}&nbsp;&nbsp;
      </option>
    </select>
    <img class="flag"
         :src="country">
  </div>
</template>

<script>
import EventBus from "@packages/event-bus/index";
import { resolveLocale, writeLocaleCookie } from "@packages/util/locale/localeCookie";

export default {
  name: "LocaleChanger",

  computed: {
    locales() {
      return [
        {
          label: this.$t("message.generics.message.portuguese"),
          value: "pt-BR",
          src: "@assets/images/brazil.png",
        },
        {
          label: this.$t("message.generics.message.spanish"),
          value: "es",
          src: "public/images/spain.png",
        },
        {
          label: this.$t("message.generics.message.english"),
          value: "en",
          src: "public/images/brazil.png",
        },
      ];
    },
    currentLocale() {
      return this.$store.state.users.locale || navigator.language;
    },
    country() {
      let path = "";
      if (this.currentLocale === "pt-BR") {
        path = "/images/brazil.png";
      } else if (this.currentLocale === "es") {
        path = "/images/spain.png";
      } else {
        path = "/images/usa.png";
      }
      return path;
    },
  },

  methods: {
    setAcceptLanguageHeader(value) {
      if (value === "pt-BR") {
        this.$http.defaults.headers.common["Accept-Language"] =
          "pt-BR,pt;q=0.5";
      } else if (value === "en") {
        this.$http.defaults.headers.common["Accept-Language"] = "en;q=0.5";
      } else if (value === "es") {
        this.$http.defaults.headers.common["Accept-Language"] = "es;q=0.6";
      }
    },
    setLocale(evt) {
      localStorage.setItem("locale", evt.target.value);
      writeLocaleCookie(evt.target.value);

      this.$store.commit("SET_LOCALE", evt.target.value);

      this.setAcceptLanguageHeader(evt.target.value);

      EventBus.$emit("LOCALE_CHANGED");
    },
  },

  mounted() {
    this.setAcceptLanguageHeader(this.currentLocale);
  },

  created() {
    const savedLanguage = resolveLocale();
    this.$store.commit("SET_LOCALE", savedLanguage);
    if (this.$i18n.locale !== savedLanguage) {
      this.$i18n.locale = savedLanguage;
    }
  },
};
</script>

<style lang="scss">
@import "~@variables";

#select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 5px;
  outline: none;
  align-self: flex-end;
  position: relative;
  margin-right: -22px;
  cursor: pointer;
  opacity: 0.001;
  width: 24px !important;
  height: 24px;
  line-height: 20px;
}

.flag {
  width: 24px;
}

option {
  font-family: "Akt", sans-serif;
  color: $grey-4;
}
</style>
